import React from "react";
import { Redirect } from "react-router-dom";
import MainPage from "../../pages/mainPage/MainPage";
import { connect } from "react-redux";
import { requestData } from "../../helpers/axios/Get";
import {
  HUB_URL,
  FETCH_PROJECTS_DATA_PENDING,
  FETCH_PROJECTS_DATA_SUCCESS,
  FETCH_PROJECTS_DATA_ERROR,
  FETCH_USER_DATA_PENDING,
  FETCH_USER_DATA_ERROR,
  FETCH_USER_DATA_SUCCESS,
  USER_URL,
} from "../../helpers/constants/Constants";
import EngineeringPage from "../../pages/EngineeringPages/EngineeringPage";
import PIDdragandDrop from "../pidLegend/PIDdragandDrop";
import SupplierZone from "../../pages/SupplierPages/SupplierZone";
import FeedBack from "../../pages/feedBack/FeedBack";
import Training from "../../pages/training/Training";
import PersonalHubPage from "../../pages/personalHub/PersonalHub";
import DSEARRegister from "../../components/dsearRegister/DSEARRegister";

class IfLoggedIn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this.props.onrequestProjectsDataReducer({ withCredentials: true });
    this.props.onrequestUserDataReducer({ withCredentials: true });
  }

  renderRedirectBack = () => {
    if (this.props.user.error.data) {
      return <Redirect to="/" />;
    }
  };

  render() {
    if (typeof this.props.user.data.name === "string") {
      switch (this.props.location.pathname) {
        case "/main":
          return (
            <>
              <MainPage />
            </>
          );
        case "/engineering":
          return (
            <>
              <EngineeringPage />
            </>
          );
        case "/SketchUp":
          return (
            <>
              <PIDdragandDrop />
            </>
          );
        case "/supplier":
          return (
            <>
              <SupplierZone />
            </>
          );
        case "/feedback":
          return (
            <>
              <FeedBack />
            </>
          );
        case "/training":
          return (
            <>
              <Training />
            </>
          );
        case "/personalHub":
          return (
            <>
              <PersonalHubPage />
            </>
          );
        case "/dsear":
          return (
            <>
              <DSEARRegister />
            </>
          );
          case "/dsearNew":
            return (
              <>
                <DSEARRegister />
              </>
            );
        default:
          return (
            <>
              <MainPage />
            </>
          );
      }
    } else {
      return (
        <div className="d-center waiting">
          {this.renderRedirectBack()}
          <h2>Waiting for user information...</h2>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  user: state.requestUserDataReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    onrequestProjectsDataReducer: (config) =>
      dispatch(
        requestData(
          HUB_URL,
          {
            pending: FETCH_PROJECTS_DATA_PENDING,
            error: FETCH_PROJECTS_DATA_ERROR,
            success: FETCH_PROJECTS_DATA_SUCCESS,
          },
          config
        )
      ),
    onrequestUserDataReducer: (config) =>
      dispatch(
        requestData(
          USER_URL,
          {
            pending: FETCH_USER_DATA_PENDING,
            error: FETCH_USER_DATA_ERROR,
            success: FETCH_USER_DATA_SUCCESS,
          },
          config
        )
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IfLoggedIn);
